import VueI18n from 'vue-i18n';

export interface INavItem {
    path: string;
    label: string;
    gaLabel: string;
}

export const getNavList = ( i18n: VueI18n ): Record<string, INavItem> => ({

    dashboard: {

        path: '/user/dashboard/',
        label: i18n.tc( 'nav.dashboard' ),
        gaLabel: 'cloud-dashborad'
    },
    cloud: {

        path: '/user/cloud-library/',
        label: i18n.tc( 'nav.cloud' ),
        gaLabel: 'cloud-my library'

    },
    device: {
        path: '/user/my-devices/',
        label: i18n.tc( 'nav.devices' ),
        gaLabel: 'cloud-my devices'
    }

});
